/**
 * Fallbacks for query results that have no data yet (loading, failed). A
 * `data = []` destructuring default builds a NEW array on every render, so
 * anything derived from it and listed in a hook dependency array changes
 * every render and re-fires its effect. These are created once.
 */
// Frozen at runtime so a stray mutation cannot leak between components; typed
// as a plain array so it fits every `T[]` prop.
export const EMPTY_LIST = Object.freeze([]) as unknown as never[];
